import React from 'react';
import styled from 'styled-components';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Toast = styled(ToastContainer)`
  .Toastify__toast--info {
    background: ''#5cb85c'';
  }
.Toastify__toast--success {
    background: '#d9534f';
  }
.Toastify__toast--warning {
    background: '#5bc0de';
  }
.Toastify__toast--error {
    background: '#f0ad4e';
  }
`;
export const showToast = ({ type, message }) => {
  switch (type) {
    case 'success':
      toast.success(message);
      break;
    case 'warn':
      toast.warn(message);
      break;
    case 'error':
      toast.error(message);
      break;
    default:
      toast.info(message);
  }
};
export default function ToastAnimated() {
  return <Toast />;
}